<section id="about-us" class="about">
  <div class="about__container">
    <div class="about__content">
      <div class="about__image" appScrollAnimate [animationDelay]="0">
        <img src="/about-us/about.jpeg" alt="Lexwood Solutions - Professional Timber Floor Installation Team in Sydney" class="about__img">
      </div>

      <div class="about__text-block" appScrollAnimate [animationDelay]="200">
        <p class="about__subtitle">ABOUT US</p>
<!--        <h2 class="about__title">Who We Are</h2>-->
        <h2 class="about__title">Lexwood Solutions</h2>
        <div class="about__divider"></div>

        <p class="about__paragraph">
          We provide professional floor sanding, installation and timber finishing services across Sydney. With over 15 years of hands-on experience, we bring European craftsmanship and attention to detail to every project.
        </p>

        <p class="about__paragraph">
          Our work combines proven expertise with Australian standards, modern dust-free equipment and premium finishing systems from trusted brands such as Bona, Loba, Berger-Seidle and Senteco, ensuring durable, high-quality results for both residential and commercial spaces.        </p>
        <ol class="about__credentials">
          <li>Licensed Carpentry Contractor (NSW) – Licence No: 468652C</li>
          <li>Fully Insured ($20M Public Liability)</li>
          <li>White Card Certified</li>
        </ol>

        <button class="about__button" (click)="navigateToContact()">GET IN TOUCH</button>
      </div>
    </div>
  </div>
</section>
